import { BREAKPOINTS } from 'foundations-components/transitional/components/Grid';
export const breakpointValues = {
  hd: 1920,
  sd: 1366,
  sdMac: 1280,
  cs: 1190,
  tablet: 1024,
  tabletPortrait: 800,
  tabletPortraitLarge: 900,
  phoneLarge: 680,
  phone: 500
};
export const isBreakpointScreen = value => {
  return value in breakpointValues;
};
const breakpointScreens = Object.keys(breakpointValues);
export const breakpoint = breakpointScreens.reduce((acc, label) => {
  acc[label] = `@media (max-width: ${breakpointValues[label] / 16}em)`;
  return acc;
}, {});

// Can be more type-strict:https://developer.mozilla.org/en-US/docs/Web/CSS/@media#media_features

export const mediaQueries = breakpointScreens.reduce((acc, label) => {
  acc[label] = `(max-width: ${breakpointValues[label] / 16}em)`;
  return acc;
}, {});
export const mobileScreen = 'tablet';

// align with trellis
export const breakpointsBySize = BREAKPOINTS;
export const isBreakpointSize = value => {
  return value in breakpointsBySize;
};
export const mediaQueryBySize = Object.entries(breakpointsBySize).reduce((acc, [size, val]) => {
  acc[size] = `(min-width: ${val}px)`;
  return acc;
}, {});